export const pickToken = (tokens, colorContext) => {
    return tokens[colorContext];
};
